<template>
  <div
    class="w-full lg:h-12 bg-black text-white p-4 lg:px-6 lg:py-0 flex items-center justify-center lg:justify-start"
  >
    <!-- Desktop -->
    <div
      class="hidden lg:flex flex-wrap lg:flex-nowrap justify-between items-center w-full"
    >
      <div class="flex items-center">
        <h6>
          {{ currentYear }} {{ settings.profile_title }}. Powered by CareerWise
          ©
        </h6>
      </div>
      <div>
        <button :class="btnClass" @click="showTermsModal">Terms of Use</button>
      </div>
    </div>

    <!-- Mobile -->
    <div class="block lg:hidden">
      <div class="w-full py-2 flex justify-center items-center">
        <h6 class="text-center">
          {{ currentYear }} {{ settings.profile_title }}. Powered by CareerWise
          ©
        </h6>
      </div>
      <div class="w-full py-2 flex justify-center items-center">
        <button :class="btnClass" @click="showTermsModal">
          <h6>Terms of Use</h6>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from '../../../js/plugins/event-bus.js'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      currentYear: new Date().getFullYear(),

      inputWrapperClass:
        'rounded relative bg-white shadow border border-truegray-300 ',
      inputLabelClass:
        'absolute transform duration-100 ease-linear px-1 left-3 top-1 z-40 text-truegray-700',
      inputTextClass:
        'flex-grow px-4 mr-0 mt-1 outline-none focus:outline-none bg-transparent w-full h-12 font-primary text-black focus:placeholder-truegray-300',
      inputTextAreaClass:
        'flex-grow px-4 mr-0 mt-5 outline-none focus:outline-none bg-transparent h-24 font-primary text-black  focus:placeholder-truegray-300 transition-all duration-100 ease-in-out w-full',
      btnClass:
        'bg-black border-none flex justify-center items-center font-primary font-semibold py-0',
    }
  },

  computed: {
    ...mapGetters({ settings: 'shared/getSettings' }),
  },

  methods: {
    showLoginModal() {
      EventBus.$emit('toggleLoginModal')
    },

    triggerLogOut() {
      EventBus.$emit('toggleLogoutModal')
    },

    showTermsModal() {
      EventBus.$emit('showModal', 'terms')
    },
  },
}
</script>
